import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import axios from "axios";
import { Link } from "react-router-dom";
import { Row, Col, Badge } from "react-bootstrap";
import bannerImage from "../../Images/programs/Post-Graduation.webp";
import EnquiryNow from "../common/EnquiryNow";

const PostGraduationProgrammes = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalShow2, setModalShow2] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        try {
          const levels = ["Postgraduate", "Post Graduate Diploma"];

          const responses = await Promise.all(
            levels.map((l) =>
              axios.get(
                `https://isbmuniversity.edu.in/admin-portal/level-courses/${encodeURIComponent(
                  l
                )}`
              )
            )
          );

          // pull out arrays (fallback to []), then merge
          const merged = responses.flatMap((r) => r?.data?.courses ?? []);

          // optional: dedupe by id (fallback to name)
          const deduped = Array.from(
            new Map(merged.map((c) => [c.id ?? c.name, c])).values()
          );

          setCourses(deduped);
        } catch (err) {
          console.error("Error fetching level courses:", err);
          setCourses([]); // or keep previous state
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setError("Failed to load courses.");
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <React.Fragment>
      <title>Postgraduate Courses at ISBM University | Advance Your Career</title>
      <meta
        name="description"
        content="Explore PG programmes at ISBM University — master’s degrees, diplomas & certificates that build expertise, employability & leadership in your field."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Postgraduate Programmes</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Postgraduate Programmes
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50 text-center">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            Advance Your Expertise with Postgraduate Studies
          </h2>
          <p>
            ISBM University offers a diverse range of postgraduate programmes
            aimed at empowering students with advanced knowledge, leadership
            skills, and specialized expertise in their chosen fields. Our
            master's degree courses include disciplines such as Management,
            Science, Commerce, Arts, Education, Information Technology, and
            more. These programmes are ideal for graduates looking to deepen
            their subject understanding and enhance their career opportunities.
          </p>

          <p>
            Our curriculum is developed in collaboration with industry
            professionals and academic experts to ensure relevance and rigor.
            Each programme combines in-depth theoretical learning with practical
            applications, case studies, and project-based assessments. Whether
            you're preparing for higher research, aiming for leadership roles,
            or planning a career shift, ISBM University’s postgraduate
            programmes provide the right platform for professional and personal
            growth.
          </p>

          <p>
            We offer flexible learning options including online and distance
            learning modes to accommodate the needs of working professionals and
            students from diverse backgrounds. With dedicated faculty support,
            modern resources, and a student-centric approach, ISBM University is
            committed to helping you achieve your academic and career
            aspirations through our high-quality postgraduate education.
          </p>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5">
                <h2 className="text-blue section-title modern-title">
                  Discover Our Courses
                </h2>
                <p className="lead">In-demand courses across industries</p>
              </div>
              <div className="row row-cols-1 row-cols-md-3 g-4">
                {Array.isArray(courses) && courses.length > 0 ? (
                  courses.map((course) => (
                    <div key={course.id} className="col p-2">
                      <div className="card rounded-3 courseBox p-0 h-100 shadow-lg bg-body border-0">
                        <div className="card-header">
                          <Link
                            to={`/course-details/${encodeURIComponent(
                              course.name
                            )}`}
                            className="text-decoration-none"
                          >
                            <h3 className="card-title font-weight-bold m-0">
                              {course.title}
                            </h3>
                          </Link>
                        </div>
                        <div className="card-body">
                          <div className="col">
                            <div className="d-flex flex-wrap gap-2 mb-2">
                              {course.level && (
                                <Badge bg="primary">{course.level}</Badge>
                              )}
                              {course.mode && (
                                <Badge bg="info">{course.mode}</Badge>
                              )}
                              {course.department && (
                                <Badge bg="secondary">
                                  {course.department}
                                </Badge>
                              )}
                            </div>
                            <Row className="info-line">
                              <i className="ti ti-file-report me-2 align-self-center"></i>
                              <p>
                                Duration: <b>{course.duration}</b>
                              </p>
                            </Row>
                            <Row className="info-line">
                              <i className="ti ti-file-text-shield me-2 align-self-center col-auto"></i>
                              <p className="col-11">
                                Eligibility: <b>{course.eligibility}</b>
                              </p>
                            </Row>
                          </div>
                          <div className="d-flex flex-wrap mt-auto">
                            <button
                              type="button"
                              class="btn btn-sm btn-download px-5 me-2"
                              onClick={() => setModalShow2(true)}
                            >
                              Apply Now
                            </button>
                            <Link
                              className="btn btn-sm btn-apply"
                              to={`/course-details/${encodeURIComponent(
                                course.name
                              )}`}
                            >
                              <span className="gdlr-core-content">
                                View Details
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No courses available.</p>
                )}
                <EnquiryNow
                  show={modalShow2}
                  onHide={() => setModalShow2(false)}
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default PostGraduationProgrammes;
